export const REMOVE_CLONE_REQUEST = 'REMOVE_CLONE_REQUEST';
export function removeCloneRequest() {
  return {
    type: REMOVE_CLONE_REQUEST,
  };
}
